import React from 'react';
import { Check } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import svg from '../../assets/images/MN9i48.tif.webp'

const Confirmation = () => {
    const location = useLocation();
    const reservationDetails = location.state || {};

    const formatTime = (time) => {
        const hours = Math.floor(time);
        const minutes = (time % 1) * 60;
        return `${hours.toString().padStart(2, '0')}:${minutes === 0 ? '00' : '30'} ${hours >= 12 ? 'PM' : 'AM'}`;
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-white py-12 px-4">
            <div className="max-w-md w-full space-y-8 text-center">
                <div className="mx-auto w-24 h-24 rounded-full bg-[#efefef] flex items-center justify-center relative">
                    <div className="absolute inset-0 border-4 border-green-500 rounded-full border-dashed"></div>
                    <img src={svg} alt='Confirmation'/>
                </div>

                <h2 className="text-4xl font-bold text-[#00b14b] tracking-tight">
                    RESERVATION
                    <br />
                    CONFIRMED
                </h2>

                <div className="bg-gray-100 rounded-lg p-8 space-y-4">
                    <p className="font-quicksand">
                        Thank you for your reservation
                        <br />
                        <span className="font-semibold">{reservationDetails.name}!</span>
                    </p>

                    <p className="text-black">
                        We have received your booking for {reservationDetails.people} on
                        <br />
                        {reservationDetails.date} at {formatTime(reservationDetails.time)} in the {reservationDetails.zone} zone.
                    </p>

                    <p className="text-black">
                        You will receive a confirmation email at
                        <br />
                        <span className="font-semibold">{reservationDetails.email}</span>
                    </p>

                    <p className="text-2xl font-bold text-[#00b14b] pt-4">
                        WE LOOK FORWARD TO
                        <br />
                        SERVE YOU!
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Confirmation;